import React from 'react';
import styled from 'styled-components';
import { Box, BoxProps } from '@material-ui/core';

export interface FixedBoxProps extends Omit<BoxProps, 'position'> {
    isBottom?: boolean;
    disableDrawerOffset?: boolean;
}

const FixedBox = styled(({ isBottom, disableDrawerOffset, ...other }: FixedBoxProps) => <Box position='fixed' {...other} />)`
    z-index: 10;
    width: 100%;
    ${({ theme, isBottom, disableDrawerOffset }) => `
    ${isBottom ? `bottom: 0;` : ''}
    ${!disableDrawerOffset
        ? `
        ${theme.breakpoints.up('md')} {
            width: calc(100% - ${theme.appDrawer.collapsedWidth}px);
        }
        ` : ``}
    `}
`;

export default FixedBox;